export const HEADER_HEIGHT_FULL = "5.75em";
export const HEADER_HEIGHT_MOBILE = "4em";

export const WEBPAGE_CORE_CONTAINER = "1800px";
export const WEBPAGE_INSIDE_CONTAINER = "1200px";
export const WEBPAGE_HORIZONTAL_PADDING = "60px";
